module.exports = __webpack_public_path__ + "img/4-112.a2b34fc1.png";